import { NgModule } from "@angular/core";
import { LayoutComponent } from "./layout.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../material.module";
import { AsyncPipe, JsonPipe, NgIf, TitleCasePipe } from '@angular/common';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@NgModule({
  declarations: [LayoutComponent, HeaderComponent, FooterComponent],
  exports: [LayoutComponent],
  imports: [
    BreadcrumbComponent,
    RouterModule,
    MaterialModule,
    AsyncPipe,
    NgIf,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    JsonPipe,
    TitleCasePipe,
  ],
})
export class LayoutModule {}
